import { render, staticRenderFns } from "./LogoBlock.vue?vue&type=template&id=96afe7f2&scoped=true"
import script from "./LogoBlock.vue?vue&type=script&lang=js"
export * from "./LogoBlock.vue?vue&type=script&lang=js"
import style0 from "./LogoBlock.vue?vue&type=style&index=0&id=96afe7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96afe7f2",
  null
  
)

export default component.exports